<template>
  <div :class="$style['pt-lab-order-dialog']">
    <el-dialog title="" :visible="dialogInfo.visible" width="30%" @close="cancel">
      <div :class="$style.title"><i :class="['iconfont','icon-yujingtishi',$style.title_icon]"></i>请确认{{dialogInfo.title}}</div>
      <div>点击“确认”，{{dialogInfo.desc}}，请谨慎操作。</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" plain @click="toSubmit" size="medium"> 确 认 </el-button>
        <el-button type="primary" plain @click="cancel" size="medium"> 取 消 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { next } from '../order-status/status.js'
// 组件class前缀
const prefixCls = 'pt-lab-order-dialog'

export default {
  name: 'pt-lab-order-dialog',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {
          visible: true
        }
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    onLoading (isSubmit) {
      this.$emit('loading', isSubmit)
    },
    toSubmit () {
      let params = this.dialogInfo
      this.cancel()
      if (params.type === 3) {
        this.onLoading(true)
        this.$store.dispatch('closeLabOrder', params.id).then((response) => {
          this.onLoading(false)
          this.$message.success('关闭订单成功！')
          this.$emit('refresh')
        }).catch((error) => {
          this.onLoading(false)
          console.error(error)
          this.$message.error(error + '关闭订单失败！')
        })
      } else {
        this.toChangeStatus().then((res) => {
          this.$emit('refresh')
        })
      }
    },
    toChangeStatus () {
      let params = this.dialogInfo
      let orderStatusResult = 'RETEST'
      if (params.type === 2) {
        orderStatusResult = 'REPORT_GENERATE'
      }
      let data = {
        orderIds: [params.id],
        action: 'COMPLETED_ORDER_RESET',
        orderStatusDetail: {
          orderStatusResult: orderStatusResult,
          labChecker1Id: this.$auth.user().fullName
        }
      }
      return next.call(this, data)
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .pt-lab-order-dialog{
    :global{
      .el-dialog__footer{
        text-align: left;
        padding: 0 .5rem .5rem
      }
      .el-dialog__body{
        padding: 0.2rem .5rem .5rem
      }
    }
    .title{
      font-size: .3rem;
      color: #333;
      margin-bottom: .4rem
    }
    .title_icon{
      color: #F56C6C;
      font-size: .4rem;
      margin-right: .3rem;
      vertical-align: middle
    }
  }
</style>
